import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styles from "./VisualitzacioMapaLlegendaItem.module.css";

function renderItems(data) {
  return data.map((item, index) => {
    return (
      <div key={index} className={styles.MapaLlegendaItemRow}>
        <div
          className={styles.MapaLlegendaItemColor}
          style={{ backgroundColor: item.color }}
        />
        <div className={styles.MapaLlegendaItemText}>{item.descripcio}</div>
      </div>
    );
  });
}

function existArray(array) {
  return Array.isArray(array);
}

class VisualitzacioMapaLlegendaItem extends PureComponent {
  render() {
    const { optionsLlegenda } = this.props;

    if (!existArray(optionsLlegenda)) {
      return null;
    }

    return (
      <div className={styles.MapaLlegenda}>{renderItems(optionsLlegenda)}</div>
    );
  }
}

VisualitzacioMapaLlegendaItem.propTypes = {
  optionsLlegenda: PropTypes.array.isRequired
};

export default VisualitzacioMapaLlegendaItem;
